import { render } from "./airtime.vue?vue&type=template&id=023d0ae8&scoped=true"
import script from "./airtime.vue?vue&type=script&lang=js"
export * from "./airtime.vue?vue&type=script&lang=js"

import "./airtime.vue?vue&type=style&index=0&id=023d0ae8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023d0ae8"]])

export default __exports__